import { render, staticRenderFns } from "./AddKNFEdit.vue?vue&type=template&id=7b4e32b1&scoped=true"
import script from "./AddKNFEdit.vue?vue&type=script&lang=js"
export * from "./AddKNFEdit.vue?vue&type=script&lang=js"
import style0 from "./AddKNFEdit.vue?vue&type=style&index=0&id=7b4e32b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e32b1",
  null
  
)

export default component.exports